<section class="container-section container-fluid g-0" [class.visible]="isVisible" #section>
  <ng-content/>
</section>
